import zipCodeUtils from '../services/zipCodeUtils';

export const useZipCode = (zipCode: string | undefined = undefined): string => {
  return zipCodeUtils.formatZipCode(zipCode);
};
